import LegalLayout from './components/LegalLayout';

const sections = [
  {
    title: '情報の正確性について',
    body: '当サイトの情報は、住宅会社・不動産・家づくりに関する一般的な知識を提供するものであり、正確性・最新性を保証するものではありません。\n掲載内容によって生じた損害について、当サイトは一切の責任を負いません。',
  },
  {
    title: '損害等の責任について',
    body: '当サイトの利用によって生じた損害・トラブルについて、当サイトは一切の責任を負いません。\n住宅会社の選定、契約、購入などは、必ずご自身の判断と責任で行ってください。',
  },
  {
    title: '外部リンクについて',
    body: '当サイトからリンクされた外部サイトの内容について、当サイトは責任を負いません。',
  },
  {
    title: 'アフィリエイトリンクについて',
    body: '当サイトでは、アフィリエイトプログラムを利用して商品・サービスを紹介する場合があります。\n紹介リンクからの購入による収益は、サイト運営費に充てられます。',
  },
];

export default function DisclaimerPage() {
  return (
    <LegalLayout
      title="免責事項"
      subtitle="鳥取ではじめての家づくり"
      lastUpdated="2026年3月"
      sections={sections}
    />
  );
}
